<div class="tree">
    <ng-container [dynamic]="model().tree"></ng-container>
</div>
